import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import './NavMenu.css';

import logout from './img/svg/Cerrar sesion.svg';

const ColoredLine = ({ color }) => (
    <hr
        style={{
            color: "#ffdb00",
            backgroundColor: "#ffdb00",
            height: 0.5
        }}
    />
);

export class Layout extends Component {
  static displayName = Layout.name; 
  render () {
    return (
        <div>

            <NavMenu />
             
            <Container> 
          {this.props.children}
            </Container>

            <ColoredLine color="#010453" />
            <Container>
                <p style={{
                    color: "#A9A9A9",
                    textAlign: "center",
                    fontSize: '0.65em',
                }}>
                    Escuela Superior Polit&eacute;cnica del Litoral - Campus Gustavo Galindo - Guayaquil - Ecuador
                    <br />
                    &#169; El contenido de esta obra es de propiedad de la ESPOL. Todos los derechos reservados.
                    <br />
                    Prohibida su reproducci&oacute;n total o parcial, comunicaci&oacute;n p&uacute;blica o distribuci&oacute;n sin autorizaci&oacute;n previa del titular de los derechos.
                </p>

            </Container>
      </div>    
    );
  }
}
